module.exports = __webpack_public_path__ + "static/media/imagemMD.909f386d.png";